import { Routes, Route } from "react-router-dom";
import Transactions from "./Pages/Transactions";
import Transactions2 from "./Pages/Transactions2";
import AgentOrders from "./Pages/AgentOrders";
import Users from "./Pages/Users";
import NewOrder from "./Pages/NewOrder";
import Rates from "./Pages/Rates";
import Rates2 from "./Pages/Rates2";
import PmiRates from "./Pages/PmiRates";
import Mail from "./Pages/Mail";
import Notificationn from "./Pages/Notification";


export default function Rotes() {
  return (
    <Routes>
      <Route path="/" element={<Users />} />
      <Route path="/new" element={<NewOrder />} />
      <Route path="/transactions" element={<Transactions />} />
      <Route path="/transactions2" element={<Transactions2 />} />
      <Route path="/agentorders" element={<AgentOrders />} />
      <Route path="/rates" element={<Rates />} />
      <Route path="/rates2" element={<Rates2 />} />
      <Route path="/pmirates" element={<PmiRates />} />
      <Route path="/mails" element={<Mail />} />
      <Route path="/notification" element={<Notificationn />} />
    </Routes>
  );
}
